//#region src/upsize_ladder_type.ts
var UpsizeLadderType = /* @__PURE__ */ function(UpsizeLadderType) {
	/** Sizes are price options on the same item; upsize = select a later price option. */
	UpsizeLadderType["PriceOption"] = "price-option";
	/** Sizes are mods in one mod group; upsize = select a later mod. */
	UpsizeLadderType["SizeMod"] = "size-mod";
	/** Sizes are separate menu items; upsize = swap to a later item. */
	UpsizeLadderType["ItemSwap"] = "item-swap";
	return UpsizeLadderType;
}(UpsizeLadderType || {});
//#endregion
export { UpsizeLadderType };

//# sourceMappingURL=upsize_ladder_type.js.map